/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit StatusInactive/view.blocks to change it.
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function StatusInactive({
  children,
  viewPath = "/DesignSystem/Svgs/StatusInactive",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 32,
  height = 32,
  fill = "none",
  stroke = "#2E2E2E"
  
}) {
  return (<React.Fragment
>
<svg
  data-testid="StatusInactive.Svg"
  data-view-path={viewPath}
 viewBox="0 0 32 32"
 style={{'--as-1-ZcijFd': alignSelf,'--mt-2-ZcijFd': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-ZcijFd': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-ZcijFd': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-ZcijFd': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-ZcijFd': opacity,'--w-7-ZcijFd': typeof width === 'number' ? `${width}px` : width,'--h-8-ZcijFd': typeof height === 'number' ? `${height}px` : height}}
 className={`views-block ${styles.Svg}`}
>
<circle
  data-testid="StatusInactive.SvgCircle"
  data-view-path={viewPath}
 strokeWidth={2.5}
 strokeLinejoin="round"
 strokeMiterlimit={10}
 cx={16}
 cy={16}
 r={14.2}
 style={{'--f-9-ZcijFd': fill,'--s-10-ZcijFd': stroke}}
 className={`views-block ${styles.SvgCircle}`}
/>
<path
  data-testid="StatusInactive.SvgPath"
  data-view-path={viewPath}
 strokeWidth={2.5}
 strokeMiterlimit={10}
 d="M21.6 10.4L10.4 21.6M21.6 21.6L10.4 10.4"
 style={{'--f-9-ZcijFd': fill,'--s-10-ZcijFd': stroke}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}